"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerBaseMock = void 0;
var PlayerBase_1 = require("../PlayerBase");
var types_1 = require("../types");
var PlayerBaseMock = exports.PlayerBaseMock = (function (_super) {
    __extends(PlayerBaseMock, _super);
    function PlayerBaseMock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supportedMimeTypes = [types_1.MIME_TYPE.MP4_VIDEO];
        _this.initializationConfig = {};
        _this.isReady = function () { return true; };
        _this.isSetup = function () { return false; };
        _this.isStalled = function () { return false; };
        return _this;
    }
    PlayerBaseMock.prototype.getPlayerName = function () {
        return PlayerBaseMock.playerName;
    };
    PlayerBaseMock.prototype.getVersion = function () {
        return PlayerBaseMock.version;
    };
    PlayerBaseMock.prototype.destroy = function () { };
    Object.defineProperty(PlayerBaseMock.prototype, "preloadMode", {
        get: function () {
            return types_1.PreloadMode.AUTO;
        },
        set: function (preloadMode) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "source", {
        get: function () {
            return this.sourceConfigurationObject;
        },
        set: function (source) {
            this.sourceConfigurationObject = source;
        },
        enumerable: false,
        configurable: true
    });
    PlayerBaseMock.prototype.preLoadChecks = function () {
        return Promise.resolve();
    };
    PlayerBaseMock.prototype.load = function () {
        return Promise.resolve();
    };
    PlayerBaseMock.prototype.unload = function () { };
    Object.defineProperty(PlayerBaseMock.prototype, "fullscreen", {
        get: function () {
            return false;
        },
        set: function (value) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "pictureInPicture", {
        get: function () {
            return false;
        },
        set: function (value) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "playbackRates", {
        get: function () {
            return [1.0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "playbackRate", {
        get: function () {
            return 1.0;
        },
        set: function (value) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "volume", {
        get: function () {
            return 1;
        },
        set: function (value) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "muted", {
        get: function () {
            return false;
        },
        set: function (muted) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "autoPlay", {
        get: function () {
            return true;
        },
        set: function (autoPlay) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "paused", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "playing", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    PlayerBaseMock.prototype.play = function () { };
    PlayerBaseMock.prototype.pause = function () { };
    Object.defineProperty(PlayerBaseMock.prototype, "live", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "ended", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "seeking", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "currentTime", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "duration", {
        get: function () {
            return 1000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "seekableRange", {
        get: function () {
            return {
                start: 0,
                end: 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "timeshiftRange", {
        get: function () {
            return {
                start: 0,
                end: 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "bufferedRanges", {
        get: function () {
            return [{ start: 0, end: 100 }];
        },
        enumerable: false,
        configurable: true
    });
    PlayerBaseMock.prototype.seek = function (value) { };
    PlayerBaseMock.prototype.getUTCTimestamp = function () {
        return null;
    };
    PlayerBaseMock.prototype.forward = function (value) { };
    PlayerBaseMock.prototype.backward = function (value) { };
    PlayerBaseMock.prototype.isOnLiveEdge = function (time) {
        return false;
    };
    Object.defineProperty(PlayerBaseMock.prototype, "selectedVideoTrack", {
        get: function () {
            return {
                id: '0',
                width: 1920,
                height: 1080,
                frameRate: 26,
                bitrate: 4800000,
                kind: types_1.TrackKind.Main,
                default: false,
                selected: true,
                type: types_1.TrackType.Video,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "selectedAudioTrack", {
        get: function () {
            return {
                id: '0',
                language: 'en',
                channels: 5,
                bitrate: 4800000,
                kind: types_1.TrackKind.Main,
                default: false,
                selected: true,
                type: types_1.TrackType.Audio,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "selectedTextTrack", {
        get: function () {
            return {
                id: '0',
                language: 'en',
                forced: false,
                kind: types_1.TrackKind.Main,
                default: false,
                selected: true,
                type: types_1.TrackType.Text,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "videoTracks", {
        get: function () {
            return [
                {
                    id: '0',
                    width: 1920,
                    height: 1080,
                    frameRate: 26,
                    bitrate: 4800000,
                    kind: types_1.TrackKind.Main,
                    default: false,
                    selected: true,
                    type: types_1.TrackType.Video,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "audioTracks", {
        get: function () {
            return [
                {
                    id: '0',
                    language: 'en',
                    channels: 5,
                    bitrate: 4800000,
                    kind: types_1.TrackKind.Main,
                    default: false,
                    selected: true,
                    type: types_1.TrackType.Audio,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "textTracks", {
        get: function () {
            return [
                {
                    id: '0',
                    language: 'en',
                    forced: false,
                    kind: types_1.TrackKind.Main,
                    default: false,
                    selected: true,
                    type: types_1.TrackType.Text,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "audioTrack", {
        get: function () {
            return null;
        },
        set: function (audioTrack) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "textTrack", {
        get: function () {
            return null;
        },
        set: function (textTrack) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "videoTrack", {
        get: function () {
            return null;
        },
        set: function (videoTrack) {
        },
        enumerable: false,
        configurable: true
    });
    PlayerBaseMock.prototype.getThumbnails = function (times) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, Array(times.length)];
            });
        });
    };
    Object.defineProperty(PlayerBaseMock.prototype, "timeline", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    PlayerBaseMock.prototype.getState = function () {
        return this.state;
    };
    PlayerBaseMock.prototype.setAbrStrategy = function () { };
    PlayerBaseMock.prototype.castToDevice = function () { };
    PlayerBaseMock.prototype.skipAd = function () { };
    Object.defineProperty(PlayerBaseMock.prototype, "canSkipAd", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    PlayerBaseMock.prototype.getMediaInfo = function () {
        return {
            currentTime: 0,
            duration: 1000,
            playerVersion: '0.0.0',
        };
    };
    Object.defineProperty(PlayerBaseMock.prototype, "adBreaks", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "currentAd", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "currentAdBreak", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "trackRestrictions", {
        get: function () {
            return null;
        },
        set: function (restrictions) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "seekingRestrictions", {
        get: function () {
            return null;
        },
        set: function (playbackRestrictions) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "performanceTweaks", {
        get: function () {
            return null;
        },
        set: function (performanceTweaks) {
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "metrics", {
        get: function () {
            return types_1.EMPTY_METRICS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayerBaseMock.prototype, "allowPlay", {
        get: function () {
            return true;
        },
        set: function (_) {
        },
        enumerable: false,
        configurable: true
    });
    PlayerBaseMock.playerName = 'mock';
    PlayerBaseMock.version = '0.0.1';
    return PlayerBaseMock;
}(PlayerBase_1.PlayerBase));
//# sourceMappingURL=PlayerBase.js.map